import { z } from 'zod';

export const SampleStatus = z.enum(
  [
    'Draft',
    'Submitted',
    'Sent',
    'NotAdmissible',
    'Analysis',
    'InReview',
    'Completed'
  ],
  {
    error: () => 'Statut non renseigné.'
  }
);

export type SampleStatus = z.infer<typeof SampleStatus>;

export const SampleStatusList: SampleStatus[] = SampleStatus.options;

export const SampleStatusLabels: Record<SampleStatus, string> = {
  Draft: 'Brouillon',
  Submitted: 'À envoyer',
  Sent: 'Transmis au labo',
  NotAdmissible: 'Non recevable',
  Analysis: 'En cours d’analyse',
  InReview: 'À valider',
  Completed: 'Terminé'
};
